import { fetchTeams } from './effects';
import { $teams } from './states';

// Fetch teams
$teams.on(fetchTeams.doneData, (_, data) => data);
